<div class="container">
  <h1 class="page-title"
    [helpCenterButton]="permissionCode" [lang]="currentLang"
    [helpCenterDownloadButton]="permissionCode" [position]="'inline'" [lang]="currentLang"><span class="icon"><i class="fas fa-list-check"></i></span>{{ 'ShippingStatus.Header' | translate }}</h1>
  <p-card>
    <p-accordion>
      <p-accordionTab header="{{ 'Common.Form.Header' | translate }}" [selected]="isSearchFormOpen">
        <form [formGroup]="searchForm">
          <div class="p-fluid formgrid grid">


            <div class="field col-12 md:col-6">
              <div class="font-bold mt-0 mb-2">{{ 'DOQuery.Header' | translate }}</div>
              <div class="formgroup-inline">
                <div class="field-radiobutton">
                  <p-radioButton formControlName="orderQueryScope" [value]="OrderQueryScopeEnum.urgent" label="{{ 'ShippingStatus.Search.Urgent' | translate }}"></p-radioButton>
                </div>
                <div class="field-radiobutton">
                  <p-radioButton formControlName="orderQueryScope" [value]="OrderQueryScopeEnum.overdue" label="{{ 'ShippingStatus.Search.OverOrder' | translate }}"></p-radioButton>
                </div>
                <div class="field-radiobutton">
                  <p-radioButton formControlName="orderQueryScope" [value]="OrderQueryScopeEnum.personal"
                    label="{{ 'ShippingStatus.Search.PersonalOrder' | translate }}"></p-radioButton>
                </div>
                <div class="field-radiobutton">
                  <p-radioButton formControlName="orderQueryScope" [value]="OrderQueryScopeEnum.all" label="{{ 'ShippingStatus.Search.All' | translate }}"></p-radioButton>
                </div>
              </div>
            </div>

            <div class="field col-12 md:col-6 hidden lg:block md:block">
              <div class="font-bold mt-0 mb-2">{{ 'ShippingStatus.Search.StatusQuery' | translate }}</div>
              <div class="formgroup-inline">
                <div class="field-radiobutton">
                  <p-radioButton formControlName="orderStatus" value="1" label="{{ 'ShippingStatus.Search.LeaveWare' | translate }}"></p-radioButton>
                </div>
                <div class="field-radiobutton">
                  <p-radioButton formControlName="orderStatus" value="2" label="{{ 'ShippingStatus.Search.HasnotLeave' | translate }}"></p-radioButton>
                </div>
                <div class="field-radiobutton">
                  <p-radioButton formControlName="orderStatus" value="3" label="{{ 'ShippingStatus.Search.All' | translate }}"></p-radioButton>
                </div>
              </div>
            </div>

            <div class="field col-12 md:col-6 lg:col-3 mb-3">
              <laas-customer-dropdown
                #customerOptions
                [divClass]="'field'"
                [labelClass]="'font-bold mt-0 mb-2'"
                [permissionCode]="permissionCode"
                [showLabel]="true"
                [isSingle]="true"
                formControlName="consigneeCompany">
              </laas-customer-dropdown>
            </div>

            <div class="field col-12 md:col-6 lg:col-3 mb-3 hidden lg:block md:block">
              <laas-facility-dropdown
                #facility
                [divClass]="'field'"
                [labelClass]="'font-bold mt-0 mb-2'"
                [permissionCode]="permissionCode"
                [showLabel]="true"
                [isMultiple]="true"
                [defaultSelectFirst]="true"
                (onOptionDataChange)="optionsDataOnChange($event, 'facility')">
              </laas-facility-dropdown>
            </div>

            <div class="field col-12 md:col-6 lg:col-3 mb-3">
              <div class="font-bold mt-0 mb-2">{{ 'ShippingStatus.Search.DONum' | translate }}</div>
              <p-chips formControlName="doNos" separator="," (onAdd)="onChipsAdd($event, 'doNos')"></p-chips>
            </div>

            <div class="field col-12 md:col-6 lg:col-3 mb-3">
              <div class="font-bold mt-0 mb-2">{{ 'ShippingStatus.Search.CustomerPO' | translate }}</div>
              <p-chips formControlName="customerPOs" separator="," (onAdd)="onChipsAdd($event, 'customerPOs')"></p-chips>
            </div>

            <div class="field col-12 md:col-6 lg:col-3 mb-3">
              <laas-tenant-org-dropdown
                [divClass]="'field'"
                [labelClass]="'font-bold mt-0 mb-2'"
                [permissionCode]="permissionCode"
                [showLabel]="true"
                [isMultiple]="true"
                (onOptionDataChange)="optionsDataOnChange($event, 'tenantOrg')">
              </laas-tenant-org-dropdown>
            </div>

            <div class="field col-12 md:col-6 lg:col-3 mb-3">
              <div class="font-bold mt-0 mb-2">{{ 'ShippingStatus.Search.InvoiceNo' | translate }}</div>
              <p-chips formControlName="invoiceNos" separator="," (onAdd)="onChipsAdd($event, 'invoiceNos')"></p-chips>
            </div>

            <div class="field col-12 md:col-6 lg:col-3 mb-3">
              <div class="font-bold mt-0 mb-2">{{ 'ShippingStatus.Search.Sales' | translate }}</div>
              <p-chips formControlName="salesCodes" separator="," (onAdd)="onChipsAdd($event, 'salesCodes')"></p-chips>
            </div>

            <div class="field col-12 md:col-6 lg:col-3 mb-3">
              <div class="font-bold mt-0 mb-2">{{ 'ShippingStatus.Search.MergeKey' | translate }}</div>
              <p-chips formControlName="mergeKeys" separator="," (onAdd)="onChipsAdd($event, 'mergeKeys')"></p-chips>
            </div>

            <div class="field col-12 mb-3">
              <div class="font-bold mt-0 mb-2">{{ 'ShippingStatus.Search.FrontLineDocStatus' | translate }}</div>
              <p-multiSelect
                formControlName="frontLineDocStatus"
                [filter]="true"
                [options]="frontLineDocStatusOptions"
                placeholder="{{ 'Common.Message.ChooseOption' | translate }}">
              </p-multiSelect>
            </div>

            <div class="field col-12 md:col-6 lg:col-6 laas-calendar">
              <laas-calendar
                #invoiceDt
                [title]="'ShippingStatus.Search.InvoiceDt'"
                [isDivTitle]="true"
                [showRangeMode]="true"
                [showStartMode]="true"
                (onDateChange)="dateOnChange($event, 'invoiceDt')">
              </laas-calendar>
            </div>

            <div class="field col-12 md:col-6 lg:col-6 laas-calendar">
              <laas-calendar
                #leaveWarehouseDt
                [title]="'ShippingStatus.Search.ShipDt'"
                [isDivTitle]="true"
                [showRangeMode]="true"
                [showStartMode]="true"
                (onDateChange)="dateOnChange($event, 'leaveWarehouseDt')">
              </laas-calendar>
            </div>

            <div class="field col-12 laas-calendar">
              <laas-calendar
                #estimateLeaveDt
                [class]="'col-3 md:col-6 mt-2'"
                [title]="'ShippingStatus.Search.EstimateLeave'"
                [isDivTitle]="true"
                [defaultDate]="defaultEstimateLeaveDt"
                [enableMaxDateIsToday]="false"
                [showCustomButtonBar]="true"
                [showRangeMode]="true"
                [showStartMode]="true"
                (onDateChange)="dateOnChange($event, 'estimateLeaveDt')">
              </laas-calendar>
            </div>

          </div>

          <div class="grid">
            <div class="col">
              <button pButton (click)="searchClick($event)" type="button" label="{{ 'Common.Button.Search' | translate }}"></button>
              <button pButton (click)="resetForm($event)" pRipple label="{{ 'Common.Button.Reset' | translate }}" class="p-button-secondary ml-2"></button>
            </div>
          </div>
      </form>
      </p-accordionTab>
    </p-accordion>
    <div class="mt-2">
      <laas-data-table [(selectedRows)]="selectedRows" (setPageSize)="setPageSize($event)" [lazy]="true"
       [selectable]="true" [dataKey]="'doNo'" (tableOnPage)="tablePageChange($event)" (tableOnSort)="tableSort($event)" [rows]="pageInfo.pageSize" [totalRecords]="pageInfo.totalRecords"
       [expandable]="false" [tableKey]="preferenceKey" [value]="results" [defaultColumns]="dataTableColumns" class="hidden md:block">
      <ng-template pTemplate="caption">
        <div class="col">
            <button pButton pRipple label="{{ 'ShippingStatus.Button.FileDownload' | translate }}" icon="pi pi-file" [disabled]="selectedRows.length == 0"
            (click)="openFileManagement($event)" class="p-button-success ml-4"></button>

            <button pButton pRipple label="{{ 'ShippingStatus.Button.FrontLineDoc' | translate }}" icon="pi pi-book" [disabled]="selectedRows.length == 0"
            (click)="frontlineDocBtnClick()" class="p-button-danger ml-4"></button>

            <!-- 客戶標籤 -->
            <button pButton pRipple label="{{ 'ShippingStatus.Button.CustomerLabel' | translate }}" icon="pi pi-tag" [disabled]="selectedRows.length == 0"
            (click)="customerLabelBtnClick()" class="p-button-help ml-4"></button>

        </div>
      </ng-template>
        <ng-template pTemplate="body" let-rowData let-columns="columns">
              <td *ngFor="let col of columns">
                  <ng-container [ngSwitch]="col.field">
                      <ng-container *ngSwitchCase="'doNo'">
                        <div class="overflow-text">
                          <a href="javascript: void(0);" (click)="gotoProgress($event, rowData.doNo)">{{rowData[col.field]}}</a>
                          <p-tag *ngIf="rowData.priority === '1'" class="ml-2" severity="danger" value="急"></p-tag>
                        </div>
                      </ng-container>
                      <ng-container *ngSwitchCase="'doStatus'">
                        <div class="overflow-text">
                          {{ rowData[col.field] | optionsMapping:DOStatusOptions }}
                        </div>
                      </ng-container>
                      <ng-container *ngSwitchCase="'consigneeKey'">
                        <div class="overflow-text">
                          {{ rowData[col.field] | optionsMapping:customerOptions.customerOptions }}
                        </div>
                      </ng-container>
                      <ng-container *ngSwitchCase="'fixedRemark'">
                        <div class="white-space: pre-line overflow-text">
                          <div [innerHTML]="rowData[col.field] | safeHtml | replaceNullWith: '-' "></div>
                        </div>
                      </ng-container>
                      <ng-container *ngSwitchCase="'cartonCnt'" >
                        <div class="overflow-text">
                          {{ rowData[col.field]
                            | number: "1.0-0"
                            | replaceNullWith: "-"
                          }}
                        </div>
                      </ng-container>
                      <ng-container *ngSwitchDefault>
                        <div [ngSwitch]="col.dataType">
                            <ng-container *ngSwitchCase="'date'">
                              <div class="overflow-text">
                                {{ rowData[col.field] | date:'yyyy-MM-dd HH:mm:ss' | replaceNullWith:'-' }}
                              </div>
                            </ng-container>
                            <ng-container *ngSwitchDefault>
                              <div class="overflow-text">
                                {{ rowData[col.field] | replaceNullWith:'-'}}
                              </div>
                            </ng-container>
                        </div>
                      </ng-container>
                      <ng-container *ngSwitchCase="'mergeKey'">
                        <div class="overflow-text">
                          {{ rowData[col.field] | replaceNullWith:'-' }}
                        </div>
                      </ng-container>
                      <ng-container *ngSwitchCase="'frontLineDocStatus'">
                        <div class="overflow-text">
                          {{ rowData[col.field] | optionsMapping:frontLineDocStatusOptions | replaceNullWith:'-' }}
                        </div>
                      </ng-container>
                    <ng-container *ngSwitchCase="'extraWorkStatus'">
                      <div class="overflow-text">
                        {{ rowData[col.field]  | optionsMapping:extraWorkStatusOptions | replaceNullWith:'-' }}
                      </div>
                    </ng-container>
                  </ng-container>
              </td>
        </ng-template>
      </laas-data-table>

      <laas-data-view class="block md:hidden" [value]="results" [paginator]="true" [rows]="pageInfo.pageSize" [totalRecords]="pageInfo.totalRecords" [lazy]="true" (onPage)="tablePageChange($event)">
        <ng-template let-result pTemplate="listItem">
          <div class="field col-12">
            <div class="p-fluid grid laas-list-item">
              <ng-container *ngFor="let col of dataViewColumns" [ngSwitch]="col.field">
                <div class="col-12 md:col-6 lg:col-4 mb-3 md:col-3 lg:col-2 mb-0 text-right">
                  <label class="font-bold mb-0">{{ col.header | translate }}</label>
                </div>

                <ng-container *ngSwitchCase="'doStatus'">
                  <div class="field col-8 md:col-3 lg:col-2 mb-0 overflow-text">
                    {{ result[col.field] | optionsMapping:DOStatusOptions }}
                  </div>
                </ng-container>

                <ng-container *ngSwitchCase="'extraWorkStatus'">
                  <div class="overflow-text">
                    {{ result[col.field]  | optionsMapping:extraWorkStatusOptions | replaceNullWith:'-' }}
                  </div>
                </ng-container>

                <ng-container *ngSwitchDefault>
                  <div class="field col-8 md:col-3 lg:col-2 mb-0" [ngSwitch]="col.dataType">
                    <ng-container *ngSwitchCase="'date'">
                      <div class="overflow-text">
                        {{ result[col.field] | date:'yyyy-MM-dd HH:mm:ss' | replaceNullWith:'-' }}
                      </div>
                    </ng-container>
                    <ng-container *ngSwitchDefault>
                      <div class="overflow-text">
                        {{ result[col.field] | replaceNullWith:'-'}}
                      </div>
                    </ng-container>
                  </div>
                </ng-container>
              </ng-container>

              <div class="col-12 text-center">
                <button pButton pRipple label="{{ 'ShippingStatus.Button.ShippingProgress' | translate }}" (click)="gotoProgress($event, result.doNo)"></button>
                <button pButton pRipple label="{{ 'ShippingStatus.Button.ShippingDetail' | translate }}" class="ml-2" (click)="gotoProgress($event, result.doNo)"></button>
              </div>

            </div>
          </div>

        </ng-template>
        <ng-template let-result pTemplate="gridItem">
          <div class="col-12 md:col-4 lg:col-3">
            <div class="p-fluid grid laas-grid-item">
                <ng-container *ngFor="let col of dataViewColumns" [ngSwitch]="col.field">
                  <div class="col-12 md:col-6 lg:col-4 mb-3 mb-0 text-right">
                    <label class="font-bold mb-0">{{ col.header | translate }}</label>
                  </div>

                  <ng-container *ngSwitchCase="'doStatus'">
                    <div class="field mb-0 col-8 overflow-text">
                      {{ result[col.field] | optionsMapping:DOStatusOptions }}
                    </div>
                  </ng-container>

                  <ng-container *ngSwitchCase="'extraWorkStatus'">
                    <div class="overflow-text">
                      {{ result[col.field]  | optionsMapping:extraWorkStatusOptions | replaceNullWith:'-' }}
                    </div>
                  </ng-container>

                  <ng-container *ngSwitchDefault>
                    <div class="field mb-0 col-8" [ngSwitch]="col.dataType">
                      <ng-container *ngSwitchCase="'date'">
                        <div class="overflow-text">
                          {{ result[col.field] | date:'yyyy-MM-dd HH:mm:ss' | replaceNullWith:'-' }}
                        </div>
                      </ng-container>
                      <ng-container *ngSwitchDefault>
                        <div class="overflow-text">
                          {{ result[col.field] | replaceNullWith:'-'}}
                        </div>
                      </ng-container>
                    </div>
                  </ng-container>
                </ng-container>

                <div class="col-12 text-center">
                  <button pButton pRipple label="{{ 'ShippingStatus.Button.ShippingProgress' | translate }}" (click)="gotoProgress($event, result.doNo)"></button>
                  <button pButton pRipple label="{{ 'ShippingStatus.Button.ShippingDetail' | translate }}" class="ml-2" (click)="gotoProgress($event, result.doNo)"></button>
                </div>

              </div>
          </div>
        </ng-template>
      </laas-data-view>
    </div>
  </p-card>
</div>

<p-dialog (onShow)="onShowFileManagement($event)" [header]="'DoNo: ' + getReferenceKeys().join(', ')" [style]="{width: '65vw'}" [(visible)]="isShowFileManagement" appendTo="body" [modal]="true" [draggable]="false" [resizable]="false">
  <ng-container>
    <laas-file-management #fileManagement [fileCategory]="deliveryOrderFileCategory" [referenceKeys]="getReferenceKeys()" [isDownloadMode]="true" [customDocTypeOptions]="customDocTypeOptions"></laas-file-management>
  </ng-container>
</p-dialog>
<help-dock
  [permissionCode]="permissionCode"
  [lang]="currentLang">
</help-dock>

<p-dialog (onShow)="onShowFrontLineDoc($event)" (onHide)="onHideFrontLineDoc($event)" [header]="'DoNo: ' + getReferenceKeys().join(', ')" [style]="{ width: '90%'}" [(visible)]="isShowTaskDocManagement" appendTo="body" [modal]="true" [draggable]="false" [resizable]="false">
  <laas-task-document #frontLineDoc
  [referenceKeys]="getReferenceKeys()"
  [fileCategory]="fileCategoryForTaskDoc"
  [canEditTable]="canEditTable"
  [canUploadDoc]="canUploadDoc"
  [canConfirm]="canConfirm"
  [uploadFileType]="uploadFileType"
  ></laas-task-document>
</p-dialog>
